import Instance from "../../../../Axios";

// New Actions for the app

const GetCredViaturas = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/viaturas`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_VIATURAS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredViaturas;
